import React, { useEffect, useState } from "react";
import shortid from "shortid";
import {
  GOOGLE_CLOUD_API_KEY,
  DEFAULT_MAP_POSITION,
} from "../../../utils/generalData";
import { CARRIER_ACTIVE_ORDER_LIST_URL } from "../../../utils/api-ends";
import useHttp from "../../../hooks/useHttp";
import LoaderImg from "../../../assets/media/loader.gif";
import CurrenLocationIcon from "../../../assets/media/icon.svg";
import { Wrapper, Status } from "@googlemaps/react-wrapper";
import { useSelector } from "react-redux";

var clint_marker_positon = null;
var endPosition = null;

var order_marker_locations = [];
var infowindow = null;

const OrderNavigation = () => {
  const { isLoading, sendRequests } = useHttp();
  const [orders, setOrders] = useState([]);
  const [orderTrakingStart, setOrderTrakingStart] = useState(false);

  const [trackInd, seTtrackInd] = useState(null);
  const [origin, setOrigin] = useState(null);
  const [destination, setDestination] = useState(null);
  const [totalrouteLenght, setTotalrouteLenght] = useState(null);
  const [currentRouteLenght, setCurrentRouteLenght] = useState(null);
  const [refreshDistanceTime, setRefreshDistanceTime] = useState(0);

  // google map init
  const google = window.google;
  const [map, setMap] = useState();
  const [mapRef, setMapRef] = useState(undefined);

  // google map services
  const [directionsService, setDirectionsService] = useState(null);
  const [directionsRenderer, setDirectionsRenderer] = useState(null);
  const [distanceMatrix, setDistanceMatrix] = useState(null);

  const carrier_watch_latLng = useSelector(
    (state) => state.carrierPosition.watchPosition
  );
  const carrier_current_latLng = useSelector(
    (state) => state.carrierPosition.currentPosition
  );

  useEffect(() => {
    const response = (data) => setOrders(data?.data);
    sendRequests({ url: CARRIER_ACTIVE_ORDER_LIST_URL }, response);
  }, [sendRequests]);

  const marker_info_content = (hour, minute) =>
    `<p className="map-marker-info"> This location located at <span>${hour}:${minute}.</span> </p>`;

  const handleSelectedRoute = (order) => {
    if (trackInd === order.tracking_id) return;
    seTtrackInd(order.tracking_id);
    setRefreshDistanceTime(0);

    if (order_marker_locations.length > 0) {
      for (let i = 0; i < order_marker_locations.length; i++) {
        order_marker_locations[i].setVisible(false);
      }
      order_marker_locations = [];
    }

    if (carrier_watch_latLng) {
      endPosition = {
        lat:
          order.order_status === "Picked Up"
            ? order.destination_details.latitude
            : order.origin_details.latitude,
        lng:
          order.order_status === "Picked Up"
            ? order.destination_details.longitude
            : order.origin_details.longitude,
      };

      // get closet route
      if (order.order_status === "Coming for Picking Up") {
        google_map_direciton_service(carrier_watch_latLng, endPosition);
        setCurrentRouteLenght(null);
      } else {
        var origin_positon = {
          lat: order.origin_details.latitude,
          lng: order.origin_details.longitude,
        };
        google_map_direciton_service(origin_positon, endPosition);
        distance_matrix_request(carrier_watch_latLng, endPosition);
      }

      // gps watch location
      if (!orderTrakingStart) {
        if (typeof carrier_watch_latLng !== "object") return;

        map.setZoom(15);
        map.panTo(carrier_watch_latLng);
        clint_marker_positon.setPosition(carrier_watch_latLng);
        clint_marker_positon.setMap(map);

        infowindow = new google.maps.InfoWindow({
          content: marker_info_content(
            new Date().getHours(),
            new Date().getMinutes()
          ),
          maxWidth: 360,
        });

        clint_marker_positon.addListener("click", () => {
          infowindow.open({
            anchor: clint_marker_positon,
            map,
            shouldFocus: false,
          });
        });
      }
    }

    !orderTrakingStart && setOrderTrakingStart(true);
  };

  const distance_matrix_request = async (from, to) => {
    const matrix_data = await distanceMatrix.getDistanceMatrix({
      origins: [from],
      destinations: [to],
      travelMode: google.maps.TravelMode.DRIVING,
      unitSystem: google.maps.UnitSystem.IMPERIAL,
    });

    if (matrix_data) {
      let direction_length =
        matrix_data.rows[0].elements[0].distance.text.split(" ")[0];

      if (matrix_data.rows[0].elements[0].distance.text.includes("mi")) {
        setCurrentRouteLenght(direction_length);
      } else {
        setCurrentRouteLenght((direction_length * 0.000189394).toFixed(4));
      }
    }
  };

  const google_map_direciton_service = (first, second) => {
    directionsRenderer.setMap(map);

    directionsService
      .route({
        origin: first,
        destination: second,
        travelMode: google.maps.TravelMode.DRIVING,
        unitSystem: google.maps.UnitSystem.IMPERIAL,
      })
      .then((response) => {
        directionsRenderer.setDirections(response);
        setOrigin(response.routes[0].legs[0].start_address);
        setDestination(response.routes[0].legs[0].end_address);

        let direction_length =
          response.routes[0].legs[0].distance.text.split(" ")[0];

        if (response.routes[0].legs[0].distance.text.includes("mi")) {
          setTotalrouteLenght(direction_length);
        } else {
          setTotalrouteLenght((direction_length * 0.000189394).toFixed(4));
        }
      })
      .catch((e) => {});
  };

  const render = (status) => {
    if (status === Status.LOADING) return <h3>{status} ..</h3>;
    if (status === Status.FAILURE) return <h3>{status} ...</h3>;
    return null;
  };

  // get route distance after 30 min
  useEffect(() => {
    if (carrier_watch_latLng && map) {
      const refreshInterval = setInterval(() => {
        setRefreshDistanceTime(refreshDistanceTime + 1);

        if (refreshDistanceTime > 30 && endPosition) {
          distance_matrix_request(carrier_watch_latLng, endPosition);
          setRefreshDistanceTime(0);
          clint_marker_positon.setPosition(carrier_watch_latLng);
          infowindow.setContent(
            marker_info_content(new Date().getHours(), new Date().getMinutes())
          );
          clint_marker_positon.setMap(map);
        }
      }, 15000);
      // 1800000
      return () => clearInterval(refreshInterval);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshDistanceTime, carrier_watch_latLng, map]);

  // zooming map in current position
  useEffect(() => {
    if (map && typeof carrier_watch_latLng === "object" && orderTrakingStart) {
      const refreshIntervalZooming = setInterval(() => {
        map.setZoom(15);
        map.panTo(carrier_watch_latLng);
      }, 20000);
      return () => clearInterval(refreshIntervalZooming);
    }
  }, [map, carrier_watch_latLng, orderTrakingStart]);

  // installation google map and services
  useEffect(() => {
    if (mapRef && !map && carrier_current_latLng) {
      setMap(
        new google.maps.Map(mapRef, {
          center: carrier_current_latLng || DEFAULT_MAP_POSITION,
          zoom: 12,
        })
      );

      setDirectionsService(new google.maps.DirectionsService());
      setDirectionsRenderer(new google.maps.DirectionsRenderer());
      setDistanceMatrix(new google.maps.DistanceMatrixService());
    }

    if (map && clint_marker_positon === null) {
      clint_marker_positon = new google.maps.Marker({
        position: carrier_current_latLng,
        map,
        icon: CurrenLocationIcon,
      });
    }
  }, [mapRef, google, map, carrier_current_latLng]);

  // set the origin or destinations marker
  useEffect(() => {
    if (orders && map) {
      order_marker_locations = [];

      orders.map((item) => {
        var marker_for_order = new google.maps.Marker({
          position: {
            lat:
              item.order_status === "Picked Up"
                ? item.destination_details.latitude
                : item.origin_details.latitude,
            lng:
              item.order_status === "Picked Up"
                ? item.destination_details.longitude
                : item.origin_details.longitude,
          },
          map,
          title: item.tracking_id,
          label: item.tracking_id,
        });

        order_marker_locations.push(marker_for_order);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orders, map]);

  return (
    <>
      <section>
        <div className="container theme-section">
          <h1 className="large-text text-center mb-4">Active Order List</h1>
          <div className="carrier-offer-table-wrapper">
            <div className="carrier-offer-table">
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">Tracking ID</th>
                    <th scope="col">Status</th>
                    <th scope="col">Origin Contact Name</th>
                    <th scope="col">Origin Contact Phone Number</th>
                    <th scope="col">Origin Address</th>
                    <th scope="col">Destination Contact Name</th>
                    <th scope="col">Destination Contact Phone Number</th>
                    <th scope="col">Destination Address</th>
                    
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  {orders?.map((order) => (
                    <tr key={shortid.generate()}>
                      <td>{order.tracking_id}</td>
                      <td>{order.order_status}</td>
                      <td>{order.origin_details?.contact_name}</td>
                      <td>{order.origin_details?.contact_phone_number}</td>
                      <td>{order.origin_details?.address}</td>
                      <td>{order.destination_details?.contact_name}</td>
                      <td>{order.destination_details?.contact_phone_number}</td>
                      <td>{order.destination_details?.address}</td>
                      
                      <td>
                        <span
                          className={
                            trackInd && trackInd === order.tracking_id
                              ? "view-button-style active-order-btn"
                              : "view-button-style"
                          }
                        >
                          <button onClick={() => handleSelectedRoute(order)}>
                            Start
                          </button>
                        </span>
                      </td>
                    </tr>
                  ))}

                  {orders?.length === 0 && (
                    <tr>
                      <td>No active orders found.</td>
                    </tr>
                  )}
                </tbody>
              </table>
              {isLoading && (
                <div className="justify-content-center d-flex mb-3 mt-2">
                  <img
                    style={{
                      width: "30px",
                    }}
                    src={LoaderImg}
                    alt="Loader"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      <section id="load-post-google-map">
        <div className="container theme-section">
          {origin && destination && totalrouteLenght && (
            <div className="order-destintaion-info">
              <ul className="ps-0 mb-5">
                <li>
                  <span>Origin: </span>
                  <span>{origin}</span>
                </li>
                <li>
                  <span>Destination: </span>
                  <span>{destination}</span>
                </li>
                <li>
                  <span>Total distance: </span>
                  <span>{totalrouteLenght} miles</span>
                </li>
                <li>
                  <span>Current distance: </span>
                  <span>
                    {currentRouteLenght ? currentRouteLenght : totalrouteLenght}{" "}
                    miles
                  </span>
                </li>
              </ul>
            </div>
          )}
          <Wrapper apiKey={GOOGLE_CLOUD_API_KEY} render={render}>
            <div ref={setMapRef} style={{ width: "100%", height: "500px" }} />
          </Wrapper>
        </div>
      </section>
    </>
  );
};

export default OrderNavigation;
